module.exports = __webpack_public_path__ + "fonts/fa-brands-400.0c9f2e8.woff2";